import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "M2.5 8V4.4c0-.22.224-.4.5-.4h7c.276 0 .5.18.5.4v15.2c0 .22-.224.4-.5.4H3c-.276 0-.5-.18-.5-.4V16M21.5 16v3.6c0 .22-.224.4-.5.4h-7c-.276 0-.5-.18-.5-.4V4.4c0-.22.224-.4.5-.4h7c.276 0 .5.18.5.4V8M21.5 12H14M10.5 12h-8"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m19.5 14 .667-.667L21.5 12l-1.333-1.334L19.5 10M4.5 14l-.667-.667L2.5 12l1.333-1.334L4.5 10"
    }, null, -1)
  ]))]))
}
export default { render: render }